import {
    GET_PRIZEPOOL_REQUEST,
    GET_PRIZEPOOL_REQUEST_SUCCESS,
    GET_PRIZEPOOL_REQUEST_FAILURE,
    GET_PRIZEPOOL_DETAIL_REQUEST,
    GET_PRIZEPOOL_DETAIL_REQUEST_SUCCESS,
    GET_PRIZEPOOL_DETAIL_REQUEST_FAILURE,
    UPDATE_PRIZEPOOL_DETAIL,
    UPDATE_PRIZEPOOL_DETAIL_SUCCESS,
    UPDATE_PRIZEPOOL_DETAIL_FAILURE
} from "../constants";

export default class PrizePoolAction {
    static GetPrizePool() {
        return {
            type: GET_PRIZEPOOL_REQUEST,
        };
    }
    static GetPrizePool_Success(payload) {
        return {
            type: GET_PRIZEPOOL_REQUEST_SUCCESS,
            payload,
        };
    }
    static GetPrizePool_Failure(payload) {
        return {
            type: GET_PRIZEPOOL_REQUEST_FAILURE,
            payload,
        };
    }

    static GetPrizePool_Detail(id, cb) {
        return {
            type: GET_PRIZEPOOL_DETAIL_REQUEST,
            id,
            cb
        };
    }
    static GetPrizePool_Detail_Success(payload) {
        return {
            type: GET_PRIZEPOOL_DETAIL_REQUEST_SUCCESS,
            payload,
        };
    }
    static GetPrizePool_Detail_Failure(payload) {
        return {
            type: GET_PRIZEPOOL_DETAIL_REQUEST_FAILURE,
            payload,
        };
    }

    static UpdatePrizePool_Detail(payload, cb) {
        
        return {
            type: UPDATE_PRIZEPOOL_DETAIL,
            payload,
            cb
        };
    }
    static UpdatePrizePool_Detail_Success(payload) {
        return {
            type: UPDATE_PRIZEPOOL_DETAIL_SUCCESS,
            payload,
        };
    }
    static UpdatePrizePool_Detail_Failure(payload) {
        return {
            type: UPDATE_PRIZEPOOL_DETAIL_FAILURE,
            payload,
        };
    }

}
